import { CheckerTypes } from "../interfaces/types";
import jsPDF from 'jspdf';


export const capitalize = (word: string | undefined) => {
    if (!word) return;

    const lowecaseWord = word.toLowerCase();
    const firstCapitalLetter = word.charAt(0).toUpperCase();
    const capitalizeWord = firstCapitalLetter + lowecaseWord.slice(1)
    return capitalizeWord;
};

export const parseToRut = (identifier: any) => {
    if (identifier.length === 9) {
        var parsedIdentifier = identifier.substring(0, identifier.length - 1) + "-" + identifier.substring(identifier.length - 1);
        return String(parsedIdentifier).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
    else {
        return String(identifier).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    }
};

export const formatInput = (value: any) => {
    var num = value.replace(/\./g, ''); // Quita los puntos
    var onlyNumber = num;

    if (isNaN(num)) { // Si tiene letra
        onlyNumber = num.replace(/[^\d\.]*/g, ''); // Quita las letras
        num = onlyNumber;
    }

    // Agrega puntos correctamente
    num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
    num = num.split('').reverse().join('').replace(/^[\.]/, '');
    var formattedNumber = num;

    return { onlyNumber, formattedNumber };
}

export const checkerType = (value: any, checker: CheckerTypes = "onlyLetters") => {
    if (checker === "onlyLetters") {
        return /^[a-zA-Z\s]*$/.test(value);
    }
    if (checker === "onlyNumbers") {
        return /^[0-9\s]*$/.test(value);
    }
    return true;
}

export const onError = (err: any) => {
    let error: any = new Error(err?.response?.data?.error?.message, { cause: err?.response?.status })
    error.statusCode = err?.response?.status;
    error.message = err?.response?.data?.error?.message;
    error.name = err?.response?.status;
    if (err?.response?.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("token");
        localStorage.setItem("error", "401");
        Promise.reject();
        window.open("/login", "_self")
        throw error;
    }
    Promise.reject();
    throw error;
}

export const generatePDF = (elementId: string) => {
    const modalContent = document.getElementById(elementId)?.innerHTML;
    if (!modalContent) return;

    const doc = new jsPDF();
    doc.setFontSize(12);

    const margins = {
        top: 10,
        bottom: 10,
        left: 10,
        right: 10,
    };
    doc.html(modalContent, {
        callback: () => {
            doc.save('comprobante.pdf');
        },
        margin: [
            margins.left,
            margins.top,
            margins.right,
            margins.bottom,
        ],
    });
};

let blackAcum: any = {};
let grayAcum: any = {};

export const parseColor = (color: string) => {
    let colorParsed: any = [];
    if (color) {
        const parsedColor = color.toLowerCase().split("/");
        if (parsedColor?.length > 1) {
            if (parsedColor[0].includes("negro")) {
                if (blackAcum[`${parsedColor[0].trim()}`]) {
                    colorParsed.push(blackAcum[`${parsedColor[0]}`]);
                }
                else if (Object.keys(blackAcum).length > 0) {
                    blackAcum[`${parsedColor[0].trim()}`] = "#0f0f0f";
                    colorParsed.push("#0f0f0f");
                }
                else {
                    blackAcum[`${parsedColor[0].trim()}`] = "black";
                    colorParsed.push("black");
                }
            }
            if (parsedColor[0].includes("gris")) {
                if (grayAcum[`${parsedColor[0].trim()}`]) {
                    colorParsed.push(grayAcum[`${parsedColor[0].trim()}`]);
                }
                else if (Object.keys(grayAcum).length > 0) {
                    grayAcum[`${parsedColor[0].trim()}`] = "#c5c5c5";
                    colorParsed.push("#c5c5c5");
                }
                else {
                    grayAcum[`${parsedColor[0].trim()}`] = "gray";
                    colorParsed.push("gray");
                }
            }
            if (parsedColor[0].includes("azul")) {
                colorParsed.push("#0047AB");
            }
            if (parsedColor[0].includes("beige")) {
                colorParsed.push("#F2E7BF");
            }
            if (parsedColor[0].includes("rojo")) {
                colorParsed.push("#d50000");
            }
            if (parsedColor[0].includes("blanco")) {
                colorParsed.push("white");
            }
            if (parsedColor[1].includes("negro")) {
                colorParsed.push("black");
            }
            if (parsedColor[1].includes("gris")) {
                if (grayAcum[`${parsedColor[1].trim()}`]) {
                    colorParsed.push(grayAcum[`${parsedColor[1].trim()}`]);
                }
                else if (Object.keys(grayAcum).length > 0) {
                    grayAcum[`${parsedColor[1].trim()}`] = "#c5c5c5";
                    colorParsed.push("#c5c5c5");
                }
                else {
                    grayAcum[`${parsedColor[1].trim()}`] = "gray";
                    colorParsed.push("gray");
                }
            }
            if (parsedColor[1].includes("azul")) {
                colorParsed.push("#0047AB");
            }
            if (parsedColor[1].includes("beige")) {
                colorParsed.push("#F2E7BF");
            }
            if (parsedColor[1].includes("rojo")) {
                colorParsed.push("#d50000");
            }
            if (parsedColor[1].includes("blanco")) {
                colorParsed.push("white");
            }
        }
        else {
            if (parsedColor[0].includes("negro")) colorParsed = ["black", "black"];
            else if (parsedColor[0].includes("gris")) {
                if (grayAcum[`${parsedColor[0].trim()}`]) {
                    colorParsed = [(grayAcum[`${parsedColor[0].trim()}`]), (grayAcum[`${parsedColor[0].trim()}`])];
                }
                else if (Object.keys(grayAcum).length > 0) {
                    grayAcum[`${parsedColor[0].trim()}`] = "#c5c5c5";
                    colorParsed = ["#c5c5c5", "#c5c5c5"];
                }
                else {
                    grayAcum[`${parsedColor[0].trim()}`] = "gray";
                    colorParsed = ["gray", "gray"];
                }
            }
            else if (parsedColor[0].includes("azul")) colorParsed = ["#0047AB", "#0047AB"];
            else if (parsedColor[0].includes("beige")) colorParsed = ["#F2E7BF", "#F2E7BF"];
            else if (parsedColor[0].includes("rojo")) colorParsed = ["#d50000", "#d50000"];
            else if (parsedColor[0].includes("blanco")) colorParsed = ["white", "white"];
            else colorParsed = ['black', "black"];
        }
    }
    return colorParsed;
};

export const checkPopupBlocker = () => {
    const popupWindow = window.open('', '_blank', 'width=1,height=1');

    if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
        alert('Para una mejor experiencia, te recomendamos habilitar las ventanas emergentes.');
        return false;
    } else {
        console.log('Las ventanas emergentes están permitidas');
        popupWindow.close();
        return true;
    }
}
